import { agreementsItemComponent } from './agreements/agreements.item.component';
import { agreementsListComponent } from './agreements/agreements.list.component';
import { AgreementService } from '../../services/agreements.service';
import { TeamService } from '../../services/team.service';
import {
    AccountsService,
    ContactsService,
    DashboardService,
    LeadsService,
    NotesService,
    TasksService
} from '../../services';
import { contactSocialComponent } from './contacts/contactSocialModal.component';
import { leadsInfoComponent } from './leads/leadsInfoModal.component';
import { contactBasicInfoComponent } from './contacts/contactBasicInfoModal.component';
import { financialInfoComponent } from './accounts/financialInfoModal.component';
import { contactInfoComponent } from './accounts/contactInfoModal.component';
import { accountBasicInfoComponent } from './accounts/accountBasicInfoModal.component';
import { crmNoteComponent } from './notes/note.component';
import { leadsItemComponent } from './leads/leads.item.component';
import { leadsListComponent } from './leads/leads.list.component';
import { leadsComponent } from './leads/leads.component';
import { crmDashboardComponent } from './crm.dashboard.component';
import { contactsItemComponent } from './contacts/contacts.item.component';
import { contactsListComponent } from './contacts/contacts.list.component';
import { contactsComponent } from './contacts/contacts.component';
import { accountsItemComponent } from './accounts/accounts.item.component';
import { accountsListComponent } from './accounts/accounts.list.component';
import { accountsComponent } from './accounts/accounts.component';
import { crmComponent } from './crm.component';
import {
    accountsItemState,
    accountsListState,
    accountsState,
    contactsItemState,
    contactsListState,
    contactsState,
    crmDashboardState,
    crmState,
    leadsItemState,
    leadsListState,
    leadsState,
    locationsItemState,
    teamsItemState,
    agreementsItemState,
    accountEmployeesItemState,
    reminderItemState
} from './crm.states';
import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { listComponent } from "../shared/list.component";
import { locationsListComponent } from "./locations/locations.list.component";
import { locationsItemComponent } from "./locations/locations.item.component";
import { teamsListComponent } from "./teams/teams.list.component";
import { teamsItemComponent } from "./teams/teams.item.component";
import { userAccountComponent } from "../shared/user-account/user-account.component";
import { accountEmployeesListComponent } from "./employees/employees.list.component";
import { accountEmployeesItemComponent } from "./employees/employees.item.component";
import { AccountEmployeeService } from "../../services/accountEmployee.service";
import { reminderIntervalComponent } from './accounts/reminderIntervalModal.component';

const crmAppModule: aboTheme.INgModule = {
    components: {
        crmComponent, crmDashboardComponent,
        accountsComponent, accountsListComponent, accountsItemComponent,
        accountBasicInfoComponent, contactInfoComponent, financialInfoComponent,
        contactsComponent, contactsListComponent, contactsItemComponent,
        contactBasicInfoComponent,
        leadsComponent, leadsListComponent, leadsItemComponent,
        crmNoteComponent, leadsInfoComponent, contactSocialComponent,
        listComponent, locationsListComponent, locationsItemComponent,
        teamsListComponent, teamsItemComponent, userAccountComponent,
        agreementsListComponent, agreementsItemComponent,
        accountEmployeesListComponent, accountEmployeesItemComponent,
        reminderIntervalComponent
    },
    states: [crmState, crmDashboardState,
        accountsState, accountsListState, accountsItemState,
        contactsState, contactsListState, contactsItemState,
        leadsState, leadsListState, leadsItemState,
        locationsItemState, teamsItemState, agreementsItemState, accountEmployeesItemState,
        reminderItemState],
    services: { ContactsService, DashboardService, AccountsService, NotesService, TasksService, LeadsService, TeamService, AgreementService, AccountEmployeeService }
};

loadNg1Module(ngmodule, crmAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/crm/index.ts